import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';

@Component({
  selector: 'app-pwa-install-prompt-modal',
  templateUrl: './pwa-install-prompt-modal.component.html',
  styleUrls: ['./pwa-install-prompt-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule]
})
export class PwaInstallPromptModalComponent {

  /** Android/Chrome/Edge: a real native install prompt can be triggered directly. False shows the manual iOS Safari "Add to Home Screen" guide instead. */
  @Input() canInstallDirectly = false;

  constructor(private modalController: ModalController) {}

  install(): void {
    this.modalController.dismiss({ action: 'install' });
  }

  dismiss(): void {
    this.modalController.dismiss({ action: 'skip' });
  }
}
